"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const NumberIntegerError_1 = require("../errors/NumberIntegerError");
const noError_1 = require("../helpers/noError");
const numberIntegerError = (value, key) => {
    const error = {
        type: NumberIntegerError_1.NumberIntegerErrorType,
        key: key,
        value: value,
    };
    return {
        error: error,
    };
};
exports.validateNumberInteger = (value, key) => {
    if (!Number.isInteger(value)) {
        return numberIntegerError(value, key);
    }
    return noError_1.noError();
};
//# sourceMappingURL=validateNumberInteger.js.map